import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: window.matchMedia("(max-width: 768px)").matches ? "top" : "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    popup: "bms-toast-popup",
  },
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

export const showSuccess = (text: string) => {
  Toast.fire({ icon: "success", title: text });
};

export const showError = (text: string) => {
  Toast.fire({ icon: "error", title: text });
};

export const showWarning = (text: string) => {
  Toast.fire({ icon: "warning", title: text });
};

export const showConfirm = async (opts: {
  title: string;
  text: string;
  confirmText?: string;
  cancelText?: string;
  icon?: "warning" | "question" | "info";
}): Promise<boolean> => {
  const result = await Swal.fire({
    title: opts.title,
    text: opts.text,
    icon: opts.icon || "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
    confirmButtonText: opts.confirmText || "OK",
    cancelButtonText: opts.cancelText || "Cancel",
    reverseButtons: true,
  });
  return result.isConfirmed;
};
